import moment from 'moment';
import 'moment-recur-ts';
import { FirebaseCourseWithUidAndImg } from '../types/types';
import { getCourseOfTheDate } from './getCourseOfTheDate';

export const getCoursesOfTheDay = (
  dayCount: number,
  courses: FirebaseCourseWithUidAndImg[] | null,
  categoryId: string | undefined,
  startOnMonday?: boolean
) => {
  const weeks: { date: string; isToday: boolean }[] = [];
  for (let i = 0; i <= dayCount - 1; i++) {
    const date = moment()
      .add(i, 'days')
      .set('hours', 0)
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .toJSON();

    const fromMondayDate = moment()
      .startOf('isoWeek')
      .add(i, 'days')
      .set('hours', 0)
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .toJSON();

    const isToday = moment(date).isSame(moment(), 'day');
    weeks.push({ date: startOnMonday ? fromMondayDate : date, isToday });
  }

  return weeks.map((weekday, idx) => ({
    ...weekday,
    id: `weekday-${weekday.date}`,
    courses: getCourseOfTheDate(
      moment(weekday.date),
      courses,
      categoryId,
      true
    ),
  }));
};
